import type { FunctionComponent, SVGProps } from 'react'
import {
  getSportIconKey,
  type SportIconKey,
} from '@sportninja/common/features/sport/utils/sportIconKey'
import { ReactComponent as GenericIcon } from './sports/sports.svg'
import { ReactComponent as BaseballIcon } from './sports/sports_baseball.svg'
import { ReactComponent as BasketballIcon } from './sports/sports_basketball.svg'
import { ReactComponent as CricketIcon } from './sports/sports_cricket.svg'
import { ReactComponent as FootballIcon } from './sports/sports_football.svg'
import { ReactComponent as HandballIcon } from './sports/sports_handball.svg'
import { ReactComponent as HockeyIcon } from './sports/sports_hockey.svg'
import { ReactComponent as RugbyIcon } from './sports/sports_rugby.svg'
import { ReactComponent as SoccerIcon } from './sports/sports_soccer.svg'
import { ReactComponent as TennisIcon } from './sports/sports_tennis.svg'
import { ReactComponent as VolleyballIcon } from './sports/sports_volleyball.svg'
import { ReactComponent as WaterPoloIcon } from './sports/pool.svg'
import { ReactComponent as EsportsIcon } from './sports/videogame_asset.svg'

interface SportIconProps {
  /** The sport's display name, e.g. "Ice Hockey". */
  sportName: string | null | undefined
  /** Icon dimensions in px (default 16). */
  size?: number
  /** Fill color; inherits the surrounding text color by default. */
  color?: string
}

// Material Icons (filled) — the same glyphs mobile draws via MaterialIcons.
const SPORT_ICONS: Record<
  SportIconKey,
  FunctionComponent<SVGProps<SVGSVGElement>>
> = {
  hockey: HockeyIcon,
  soccer: SoccerIcon,
  handball: HandballIcon,
  tennis: TennisIcon,
  baseball: BaseballIcon,
  basketball: BasketballIcon,
  volleyball: VolleyballIcon,
  football: FootballIcon,
  rugby: RugbyIcon,
  waterPolo: WaterPoloIcon,
  cricket: CricketIcon,
  esports: EsportsIcon,
  generic: GenericIcon,
}

/** A sport's glyph, decorative — pair it with the sport's name. */
const SportIcon = ({
  sportName,
  size = 16,
  color = 'currentColor',
}: SportIconProps) => {
  const Icon = SPORT_ICONS[getSportIconKey(sportName)]
  return (
    <Icon
      width={size}
      height={size}
      fill={color}
      aria-hidden='true'
      focusable='false'
    />
  )
}

export default SportIcon
